// context/DarkModeContext.js
import { createContext, useContext, useEffect, useState } from "react";

const DarkModeContext = createContext();

export const DarkModeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("darkMode") === "true";
  });

  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem("darkMode", newDarkMode);
    document.documentElement.classList.toggle("dark", newDarkMode);
    document.body.classList.toggle("dark", newDarkMode);
  };

  useEffect(() => {
    document.body.classList.add("bg-lightmode", "bg-cover", "bg-center", "min-h-screen");
    if (darkMode) {
      document.documentElement.classList.add("dark");
      document.body.classList.add("bg-darkmode");
      document.body.classList.remove("bg-lightmode");
    } else {
      document.documentElement.classList.remove("dark");
      document.body.classList.remove("bg-darkmode");
      document.body.classList.add("bg-lightmode");
    }
  }, [darkMode]);

  return (
    <DarkModeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
};

export const useDarkMode = () => useContext(DarkModeContext);
